import ProcurementProjectType from './ProcurementProjectTypes';

export const getProcurementProjectListInProgress = (payload) => {
  return { type: ProcurementProjectType.GET_PROCUREMENT_PROJECT_LIST, payload };
};

export const getProcurementProjectListInSuccess = (payload) => {
  return {
    type: ProcurementProjectType.GET_PROCUREMENT_PROJECT_LIST_SUCCESS,
    payload,
  };
};

export const getProcurementProjectListInFail = (payload) => {
  return {
    type: ProcurementProjectType.GET_PROCUREMENT_PROJECT_LIST_FAIL,
    payload,
  };
};

export const getProcurementProjectListUpdate = (payload) => {
  return {
    type: ProcurementProjectType.PROCUREMENT_PROJECT_LIST_UPDATE,
    payload,
  };
};

export const getProcurementProjectListRequestReset = () => {
  return {
    type: ProcurementProjectType.GET_PROCUREMENT_PROJECT_LIST_REQUEST_RESET,
  };
};

export const updateProcurementProjectInfoRequest = () => {
  return {
    type: ProcurementProjectType.UPDATE_PROCUREMENT_PROJECT_INFO_REQUEST,
  };
};

export const checkProjectNameIsExists = (payload) => {
  return { type: ProcurementProjectType.CHECK_PROJECT_NAME_IS_EXISTS, payload };
};

export const checkProjectNameIsExistsSuccess = (payload) => {
  return {
    type: ProcurementProjectType.CHECK_PROJECT_NAME_IS_EXISTS_SUCCESS,
    payload,
  };
};

export const checkProjectNameIsExistsFail = (payload) => {
  return {
    type: ProcurementProjectType.CHECK_PROJECT_NAME_IS_EXISTS_FAIL,
    payload,
  };
};

/** get user procurement actions start */

export const getUserProcurementInProgress = (payload) => {
  return { type: ProcurementProjectType.GET_USER_PROCUREMENT, payload };
};

export const getUserProcurementInSuccess = (payload) => {
  return { type: ProcurementProjectType.GET_USER_PROCUREMENT_SUCCESS, payload };
};

export const getUserProcurementInFail = (payload) => {
  return { type: ProcurementProjectType.GET_USER_PROCUREMENT_FAIL, payload };
};

export const getUserProcurementRequestReset = () => {
  return { type: ProcurementProjectType.GET_USER_PROCUREMENT_REQUEST_RESET };
};

/** get user procurement actions end */

/** get tender by project list actions start */

export const getTenderByProjectListInProgress = (payload) => {
  return { type: ProcurementProjectType.GET_TENDER_BY_PROJECT_LIST, payload };
};

export const getTenderByProjectListInSuccess = (payload) => {
  return {
    type: ProcurementProjectType.GET_TENDER_BY_PROJECT_LIST_SUCCESS,
    payload,
  };
};

export const getTenderByProjectListInFail = (payload) => {
  return {
    type: ProcurementProjectType.GET_TENDER_BY_PROJECT_LIST_FAIL,
    payload,
  };
};

export const getTenderByProjectListRequestReset = () => {
  return {
    type: ProcurementProjectType.GET_TENDER_BY_PROJECT_LIST_REQUEST_RESET,
  };
};

/** get tender by project list actions end */

/** create and update project actions start */

export const createUpdateProjectInProgress = (payload) => {
  return { type: ProcurementProjectType.CREATE_UPDATE_PROJECT, payload };
};

export const createUpdateProjectInSuccess = (payload) => {
  return {
    type: ProcurementProjectType.CREATE_UPDATE_PROJECT_SUCCESS,
    payload,
  };
};

export const createUpdateProjectInFail = (payload) => {
  return {
    type: ProcurementProjectType.CREATE_UPDATE_PROJECT_FAIL,
    payload,
  };
};

export const createUpdateProjectRequestReset = () => {
  return {
    type: ProcurementProjectType.CREATE_UPDATE_PROJECT_REQUEST_RESET,
  };
};

/** create and update project actions end */

/** get project copy action start */

export const getProjectCopyInProgress = (payload) => {
  return {
    type: ProcurementProjectType.CREATE_PROJECT_COPY,
    payload,
  };
};

export const getProjectCopyInSuccess = (payload) => {
  return {
    type: ProcurementProjectType.CREATE_PROJECT_COPY_SUCCESS,
    payload,
  };
};

export const getProjectCopyInFail = (payload) => {
  return {
    type: ProcurementProjectType.CREATE_PROJECT_COPY_FAIL,
    payload,
  };
};

export const getProjectCopyRequestReset = () => {
  return {
    type: ProcurementProjectType.CREATE_PROJECT_COPY_RESET,
  };
};

/** get project copy action end */

/** Active Project item start */
export const setActiveProjectItemsRequest = (payload) => {
  return {
    type: ProcurementProjectType.SET_ACTIVE_PROJECT_ITEM,
    payload,
  };
};

export const resetActiveProjectItemsRequest = () => {
  return {
    type: ProcurementProjectType.RESET_ACTIVE_PROJECT_ITEM,
  };
};

export const setSelectedProjectAction = (payload) => {
  return {
    type: ProcurementProjectType.SET_SELECTED_PROJECT_ACTION,
    payload,
  };
};
/** Active Project item end */
